import React from "react";
import { SimManager } from "@learningblocks/simulation-engine";
import { FullscreenModal } from "@learningblocks/storybook-components";

import styles from "./RestartStep.module.scss";
import ProtocolOverviewIcon from "./images/RestartStep-icon.svg";

export interface RestartStepProps {
  show: boolean;
  close: (hintTaken: boolean) => void;
  hintsLeft: number;
}

export class RestartStep extends React.Component<RestartStepProps> {
  constructor(props: RestartStepProps) {
    super(props);
  }

  noClicked = () => {
    this.props.close(false);
  };

  yesClicked = () => {
    if (this.props.hintsLeft > 0) SimManager.getInstance().redoButtonPressed();

    this.props.close(true);
  };

  render() {
    return (
      <FullscreenModal
        className="modalContainer"
        isOpen={true}
        closeButton={false}
        notebookExpanded={false}
        close={this.props.close}
        backLabel={"Lab"}
      >
        <div className={styles.Question}>
          <div className={styles.containerProtocolOverview}>
            <div
              className={`${styles["modal-section"]} ${styles["level-choice"]}`}
            >
              <img
                src={ProtocolOverviewIcon}
                style={{ height: "70px" }}
                alt="Protocol Overview icon"
              />
              <h4
                className={styles.restartModalHeading}
                aria-label={"Are you sure you want to undo this step?"}
              >
                Are you sure you want to undo this step?
              </h4>
              <p
                className={styles.restartsLeftText}
                aria-label={"1 restarts left"}
              >
                {this.props.hintsLeft} restarts left
              </p>
              <div className={styles["modal-footer"]}>
                <button
                  aria-label={"No"}
                  tabIndex={0}
                  className={`${styles["modal-btn-secondary"]} ${styles["lvl-choice"]}`}
                  onClick={this.noClicked}
                >
                  No
                </button>
                <button
                  aria-label={"Yes"}
                  tabIndex={0}
                  className={`${styles["modal-btn-primary"]} ${styles["lvl-choice"]}`}
                  onClick={this.yesClicked}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </FullscreenModal>
    );
  }
}

export default RestartStep;
